import {Injectable} from '@angular/core';
import {ToastProvider} from "../toast/toast";

/*
  Generated class for the ValidationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ValidationProvider {

  isValid: boolean;
  messages: any = [];

  constructor(private toast: ToastProvider) {
  }

  init() {
    this.isValid = true;
    this.messages = [];
  }

  addError(message: string) {
    this.messages.push(message);
    this.isValid = false;
  }

  showMessages() {
    for (let msg of this.messages) {
      this.toast.error(msg);
    }

    // let message = `Arbeitsbericht konnte nicht gespeichert werden, folgende Fehler sind aufgetreten: `;
  }
}



// WEBPACK FOOTER //
// ./src/providers/validation/validation.ts